module.exports = __webpack_public_path__ + "static/media/after-5-icon.33788a1b.svg";